import { BaseTabBar, BaseTabBarProps } from './__internal__/';
import { createElement, useState } from 'react';
import { OmitStrict } from '../../utility-types';

export interface TabBarProps
  extends OmitStrict<BaseTabBarProps, 'expandCollapseProps' | 'focusedIndex' | 'setFocusedIndex'> {}

export const TabBar = (props: TabBarProps) => {
  const [focusedIndex, setFocusedIndex] = useState<number>(
    props.selectedIndex < 0 ? 0 : props.selectedIndex
  );
  return <BaseTabBar focusedIndex={focusedIndex} setFocusedIndex={setFocusedIndex} {...props} />;
};
